import { render, staticRenderFns } from "./Role.vue?vue&type=template&id=16dc0b0c&scoped=true"
import script from "./Role.vue?vue&type=script&lang=ts"
export * from "./Role.vue?vue&type=script&lang=ts"
import style0 from "./Role.vue?vue&type=style&index=0&id=16dc0b0c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16dc0b0c",
  null
  
)

export default component.exports